import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const AnalyticsTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Check if gtag exists (it should be loaded from index.html)
        if (window.gtag) {
            window.gtag('config', 'G-DYV01ZP6C7', {
                page_path: location.pathname + location.search,
            });
        }
    }, [location]);

    return null;
};

export default AnalyticsTracker;
